import React from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { createContext } from 'src/util'
import useHandler from 'src/hooks/useHandler'
import { Modal } from 'src/components'

const defaultValue = { open: noop, close: noop, createModalOpener: () => noop }

/**
 * Creates a context for managing a modal.
 */
export default createContext(Provider => {
  function ModalContext({ children }) {
    // initialize modal ref
    const ref = React.useRef()

    // initialize modal state
    const [state, setState] = React.useState({ isOpen: false, children: null })

    // create open handler
    const open = useHandler(children => setState({ isOpen: true, children }))

    // create an open handler creator
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const createModalOpener = children => useHandler(() => open(children))

    // create close handler
    const close = useHandler(() => setState(state => ({ ...state, isOpen: false })))

    return (
      <Provider value={{ open, close, createModalOpener }}>
        {children}
        <Modal modalRef={ref} close={close} {...state} />
      </Provider>
    )
  }

  ModalContext.propTypes = {
    children: PropTypes.node,
  }

  return ModalContext
}, defaultValue)
